import { Routes, Route, Navigate, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { AuthProvider } from './contexts/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import { Layout } from './components/Layout'
import { Header } from './components/landing/Header'
import { Footer } from './components/landing/Footer'
import { ScrollToTop } from './components/ScrollToTop'
import { LandingPage } from './pages/LandingPage'
import { LoginPage } from './pages/LoginPage'
import { SignUpPage } from './pages/SignUpPage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { DashboardPage } from './pages/DashboardPage'
import { ApiKeysPage } from './pages/ApiKeysPage'
import { ProfilePage } from './pages/ProfilePage'
import { PricingPage } from './pages/PricingPage'
import { TermsPage } from './pages/TermsPage'
import { PrivacyPage } from './pages/PrivacyPage'
import { DocumentationPage } from './pages/DocumentationPage'
import { useAuth } from './contexts/AuthContext'
import { identifyUser, resetUser } from './utils/posthog'

function PublicDocumentationPage() {
  const navigate = useNavigate()
  const { user } = useAuth()
  return (
    <div className="min-h-screen bg-bg flex flex-col">
      <Header
        isAuthenticated={!!user}
        onDashboardClick={() => navigate(user ? '/dashboard' : '/login')}
        onSignUpClick={() => navigate('/signup')}
      />
      <main className="flex-1 pt-24 pb-12 px-4 sm:px-6">
        <div className="container-custom">
          <DocumentationPage />
        </div>
      </main>
      <Footer />
    </div>
  )
}

function AppInner() {
  const { user } = useAuth()

  useEffect(() => {
    if (user) {
      identifyUser(user.userId)
    } else {
      resetUser()
    }
  }, [user])

  return (
    <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/documentation" element={<PublicDocumentationPage />} />
        <Route path="/dashboard" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<DashboardPage />} />
          <Route path="api-keys" element={<ApiKeysPage />} />
          <Route path="documentation" element={<DocumentationPage />} />
          <Route path="profile" element={<ProfilePage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
  )
}

function App() {
  return (
    <AuthProvider>
      <ScrollToTop />
      <AppInner />
    </AuthProvider>
  )
}

export default App